import { getSessionToken } from './auth';

export type ChatSocketEvent =
  | { type: 'connected'; data: { userId: string; username: string; timestamp: number; message?: string } }
  | { type: 'message'; data: { id: string; roomId: string; chatId?: string; senderId: string; senderName?: string; content: string; timestamp: number } }
  | { type: 'typing'; data: { roomId: string; userId: string; isTyping: boolean; timestamp: number } }
  | { type: 'user_online'; data: { userId: string; username?: string; timestamp: number } }
  | { type: 'user_offline'; data: { userId: string; username?: string; timestamp: number } }
  | { type: 'error'; data: { error: string; timestamp: number } };

export interface ChatSocketOptions {
  roomId: string;
  userId: string;
  onMessage: (event: ChatSocketEvent) => void;
  onError?: (error: Event) => void;
  onClose?: () => void;
}

function getWebSocketBaseUrl(): string {
  if (typeof window === 'undefined') {
    return '';
  }
  const { protocol, host } = window.location;
  const wsProtocol = protocol === 'https:' ? 'wss:' : 'ws:';
  return `${wsProtocol}//${host}`;
}

export function createChatSocket({ roomId, userId, onMessage, onError, onClose }: ChatSocketOptions): WebSocket | null {
  const token = getSessionToken();
  if (!token) return null;

  const url = new URL('/api/ws', getWebSocketBaseUrl());
  url.searchParams.set('roomId', roomId);
  url.searchParams.set('userId', userId);
  url.searchParams.set('token', token);

  const socket = new WebSocket(url.toString());

  socket.addEventListener('message', (event) => {
    try {
      const payload = JSON.parse(event.data) as ChatSocketEvent;
      onMessage(payload);
    } catch {
      // ignore malformed payloads
    }
  });

  socket.addEventListener('error', (event) => {
    if (onError) onError(event);
  });

  socket.addEventListener('close', () => {
    if (onClose) onClose();
  });

  return socket;
}
